import { animate, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';

export default trigger('quickFadeIn', [
  transition('* => *', [
    query(':self', style({ opacity: 0 }), { optional: true }),
    query(
      ':self',
      stagger('300ms', [
        animate(
          '0.2s ease-in',
          keyframes([
            style({ opacity: 0, offset: 0 }),
            style({
              opacity: 0.5,
              offset: 0.3,
            }),
            style({ opacity: 1, offset: 1 }),
          ])
        ),
      ]),
      { optional: true }
    ),
  ]),
]);
